import { useCallback, useEffect, useRef, useState } from "react";
import { api, errMsg } from "@/lib/api";

export function useFetch(url) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const seq = useRef(0);

  const load = useCallback(async () => {
    const mine = ++seq.current;
    if (!url) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const r = await api.get(url);
      if (mine !== seq.current) return;
      setData(r.data);
      setError(null);
    } catch (e) {
      if (mine === seq.current) setError(errMsg(e));
    } finally {
      if (mine === seq.current) setLoading(false);
    }
  }, [url]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load, setData };
}
